import React from "react";
import imgDefaultAva from "./default-ava.webp";

export default function AvatarImg() {
  return <img alt="avatar" src={imgDefaultAva} width={40} />;
}
